import { Component, ElementRef, HostBinding, Input, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';

const DEFAULT_PRIMARY = '#FED33C';
const DEFAULT_SECONDARY = '#F16821';

@Component({
  selector: 'ca-image-loader',
  templateUrl: './image-loader.component.html',
  styleUrls: ['./image-loader.component.scss']
})
export class ImageLoaderComponent {
  _image: string | false;

  get image() {
    return this._image;
  }

  @Input()
  showPlaceholder = true;

  @Input()
  set image(data) {
    let newImage;
    if (!data) {
      newImage = false;
    } else {
      if (Array.isArray(data)) {
        newImage = data[0];
      } else {
        newImage = data;
      }
    }
    if (newImage !== this._image) {
      this._image = newImage;
      this.imageLoaded = false;
    }
  }

  /**
   * Whether or not to show the branded background gradient as placholder.
   * Set to false if you are styling the image-loader from another component's styles.
   */
  @Input()
  title: string = '';
  @HostBinding('class.has-background')
  @Input()
  background = true;

  @HostBinding('class.has-contain')
  @Input()
  contain = false;
  imageLoaded = false;

  @ViewChild('imgEl')
  imgEl: ElementRef;

  @HostBinding('class.init')
  init = false;

  @HostBinding('style.backgroundImage')
  get hostBackground() {
    return this.background ? this.gradient : '';
  }

  get localBackground() {
    return this.image && this.imageLoaded ? `url(${this.image})` : ``;
  }

  get gradient() {
    return this.showPlaceholder
      ? `linear-gradient(to top right, ${this.primary || DEFAULT_PRIMARY}, ${this.secondary ||
          DEFAULT_SECONDARY})`
      : 'transparent';
  }

  primary: string = DEFAULT_PRIMARY;
  secondary: string = DEFAULT_SECONDARY;
  placeholder: string;

  ngAfterContentInit() {
    if (this.imageLoaded) return;
    this.init = true;
  }

  setImageLoaded() {
    this.imageLoaded = true;
  }

  get brandedPlaceholder() {
    return `url(${this.placeholder})`;
  }
  get defaultPlaceholder() {
    return `url('assets/svg/logo-square-light.svg')`;
  }

  constructor(public store: Store<any>) {}
}
